<template></template>

<script>
export default {
    data() {
        return {
            //
        }
    },
    methods: {
        //
    },
    mounted() {
        //
    },
}
</script>
